/* eslint-disable @nx/enforce-module-boundaries */
import {
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalHeader,
  ModalOverlay,
} from '@mybridge/ui';
import { forwardRef, useContext } from 'react';
import { DashboardPostForm } from 'v4/snippets/dashboard/post-form';
import { MyProfileContext } from '../context';
export const MyProfileCreatePostModal = forwardRef(({ ...props }, ref) => {
  const { refetchActivityPosts, activityDisc } = useContext(MyProfileContext);
  return (
    <Modal size="xl" {...props}>
      <ModalOverlay />
      <ModalContent>
        <ModalCloseButton />
        <ModalHeader>Create a post</ModalHeader>
        <ModalBody>
          <DashboardPostForm
            onCreateSuccess={(e) => {
              activityDisc?.onClose?.();
              refetchActivityPosts();
            }}
          />
        </ModalBody>
      </ModalContent>
    </Modal>
  );
});
